// extracted by mini-css-extract-plugin
export default {"client-description-field":"DescriptionForm_client-description-field__mROfI"};